import type { IconPrimitives, IconProps } from './types';

export const buildGeneralIcons = ({ Svg, Path, Circle, Rect, Ellipse, defaultColor }: IconPrimitives) => ({
  DirectionsIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path
        d='M16 10.965L16.3336 10.6311L16.6677 10.965L16.3336 11.2989L16 10.965ZM10 15L9.52806 15L9.52806 12.6317L10 12.6317L10.4719 12.6317L10.4719 15L10 15ZM10 12.6317L9.52806 12.6317C9.52806 12.3509 9.58338 12.0728 9.69086 11.8133L10.1269 11.9939L10.5629 12.1745C10.5028 12.3195 10.4719 12.4748 10.4719 12.6317L10 12.6317ZM10.1269 11.9939L9.69086 11.8133C9.79834 11.5538 9.95587 11.3181 10.1545 11.1195L10.4882 11.4532L10.8219 11.7869C10.7109 11.8978 10.6229 12.0295 10.5629 12.1745L10.1269 11.9939ZM10.4882 11.4532L10.1545 11.1195C10.3531 10.9209 10.5888 10.7633 10.8483 10.6559L11.0289 11.0919L11.2095 11.5279C11.0645 11.5879 10.9328 11.6759 10.8219 11.7869L10.4882 11.4532ZM11.0289 11.0919L10.8483 10.6559C11.1078 10.5484 11.3859 10.4931 11.6667 10.4931L11.6667 10.965L11.6667 11.4369C11.5098 11.4369 11.3544 11.4678 11.2095 11.5279L11.0289 11.0919ZM11.6667 10.965L11.6667 10.4931L16 10.4931L16 10.965L16 11.4369L11.6667 11.4369L11.6667 10.965ZM16 10.965L15.6664 11.2989L13.6997 9.33386L14.0333 9L14.3669 8.66614L16.3336 10.6311L16 10.965ZM16 10.965L16.3336 11.2989L14.3669 13.2639L14.0333 12.93L13.6997 12.5961L15.6664 10.6311L16 10.965Z'
        fill={color}
      />
      <Rect x='4' y='12' width='12' height='12' transform='rotate(-45 4 12)' stroke={color} strokeWidth='0.943875' />
    </Svg>
  ),
  CheckIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 22.0808 21.4998' fill='none' {...props}>
      <Path d='M3.04041 11.3999L8.54041 17.3999L19.5404 4.3999' stroke={color} />
    </Svg>
  ),
  LockIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path
        d='M8.5 11.5V9.75C8.5 7.95507 9.95507 6.5 11.75 6.5H12.25C14.0449 6.5 15.5 7.95507 15.5 9.75V11.5'
        stroke={color}
        strokeWidth='1.25'
        strokeLinecap='round'
      />
      <Rect x='7' y='11.5' width='10' height='7' rx='1.25' stroke={color} strokeWidth='1.25' />
      <Circle cx='12' cy='14.25' r='1' fill={color} />
      <Path d='M12 15V16.75' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
    </Svg>
  ),
  LeftIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path d='M14.9 6L12 9L9.1 12L12 15L14.9 18' stroke={color} />
    </Svg>
  ),
  RightIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path d='M9.1 6L12 9L14.9 12L12 15L9.1 18' stroke={color} />
    </Svg>
  ),
  EditIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24.4528 24.4528' fill='none' {...props}>
      <Path d='M2.24574 18.7071L20.2457 0.707107L23.7457 4.20711L5.74574 22.2071L0.745736 23.7071L2.24574 18.7071Z' stroke={color} strokeMiterlimit={10} />
      <Path d='M5.74574 22.2071L2.24574 18.7071' stroke={color} strokeMiterlimit={10} strokeLinejoin='round' />
      <Path d='M21.2457 6.70711L17.7457 3.20711' stroke={color} strokeMiterlimit={10} strokeLinejoin='round' />
    </Svg>
  ),
  LiveIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path d='M8.09 14.8C7.31 14.06 6.82 13 6.82 11.84C6.82 10.77 7.23 9.8 7.9 9.08' stroke={color} />
      <Path d='M15.73 9.08C16.51 9.82 17 10.87 17 12.04C17 13.1 16.59 14.07 15.92 14.8' stroke={color} />
      <Path d='M5.97 17.02C4.76 15.7 4 13.83 4 11.77C4 9.87 4.64 8.15 5.68 6.86' stroke={color} />
      <Path d='M17.56 6.86C18.95 8.18 19.82 10.05 19.82 12.11C19.82 14 19.09 15.73 17.91 17.02' stroke={color} />
      <Circle cx='12.41' cy='11.98' r='1.69' fill={color} />
    </Svg>
  ),
  WalkIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path
        d='M15.13 8.5C14.32 8.16 13.43 7.99 12.54 8C11.65 7.99 10.77 8.16 9.95 8.5C9.14 8.85 8.42 9.35 7.84 9.99C7.29 10.57 6.85 11.24 6.54 11.97C6.85 12.7 7.29 13.37 7.84 13.96C8.42 14.59 9.14 15.09 9.95 15.44C10.77 15.78 11.65 15.95 12.54 15.94C13.43 15.95 14.32 15.78 15.13 15.44C15.94 15.09 16.66 14.59 17.24 13.96C17.8 13.37 18.24 12.7 18.54 11.97C18.24 11.24 17.8 10.57 17.24 9.99C16.66 9.35 15.94 8.85 15.13 8.5Z'
        stroke={color}
        strokeLinecap='round'
      />
      <Circle cx='12.61' cy='12.04' r='1.7' stroke={color} strokeWidth='1.13' />
    </Svg>
  ),
  DetailsIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path d='M12 5V18.86' stroke={color} />
      <Path d='M6.25 8.46L17.75 15.39' stroke={color} />
      <Path d='M6.25 15.39L17.75 8.46' stroke={color} />
    </Svg>
  ),
  CalendarIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path d='M22.5 7.5H0.5V23.5H22.5V7.5Z' stroke={color} strokeMiterlimit={10} strokeLinejoin='round' />
      <Path d='M0.5 7.5V2.5H22.5V7.5' stroke={color} strokeMiterlimit={10} strokeLinejoin='round' />
      <Path d='M11.5 4.5V0.5' stroke={color} strokeMiterlimit={10} strokeLinejoin='round' />
      <Path d='M17.5 4.5V0.5' stroke={color} strokeMiterlimit={10} strokeLinejoin='round' />
      <Path d='M5.5 4.5V0.5' stroke={color} strokeMiterlimit={10} strokeLinejoin='round' />
    </Svg>
  ),
});
